export { default as DataDisplayTable } from './src/data-display-table';
